import React from "react";

const Contact = () => {
  return (
    <div className="">
      {/* Hero Section */}
      <div className="container mx-auto py-20 px-6 bg-gradient-to-r from-[#ae3e34] to-[#f7b6a5] text-white rounded-lg shadow-lg mt-12 mb-12">
        <h1 className="text-5xl font-bold text-center mb-6">Contact Us</h1>
        <p className="text-lg text-center max-w-3xl mx-auto">
          We're here to assist you. Reach out to us for any inquiries, support, or feedback. Your satisfaction is our top priority.
        </p>
      </div>

      {/* Contact Information & Form Section */}
      <div className="container mx-auto px-6 grid md:grid-cols-2 gap-12 mb-20">
        {/* Contact Info */}
        <div className="bg-white p-8 rounded-lg shadow-lg">
          <h2 className="text-2xl font-semibold text-[#ae3e34] mb-6">Get in Touch</h2>
          <p className="text-gray-700 mb-4">
            We'd love to hear from you! Feel free to contact us via the following methods.
          </p>
          <div className="space-y-4 text-gray-800">
            <div>
              <span className="font-semibold">Email:</span>{" "}
              <a href="mailto:info@bricksnbar.com" className="text-[#ae3e34] hover:underline">
                info@bricksnbar.com
              </a>
            </div>
            <div>
              <span className="font-semibold">Phone:</span>{" "}
              <span className="text-[#ae3e34]">+123-456-7890</span>
            </div>
            <div>
              <span className="font-semibold">Address:</span>
              <p>123 Construction Lane, Buildtown, Country</p>
            </div>
          </div>
        </div>

        {/* Contact Form */}
        <div className="bg-white p-8 rounded-lg shadow-lg">
          <h2 className="text-2xl font-semibold text-[#ae3e34] mb-6">Send a Message</h2>
          <form className="space-y-6">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">Full Name</label>
              <input
                type="text"
                placeholder="Your Name"
                className="w-full border border-gray-300 rounded-lg px-4 py-2 focus:outline-none focus:ring-2 focus:ring-[#ae3e34]"
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">Email Address</label>
              <input
                type="email"
                placeholder="you@example.com"
                className="w-full border border-gray-300 rounded-lg px-4 py-2 focus:outline-none focus:ring-2 focus:ring-[#ae3e34]"
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">Message</label>
              <textarea
                placeholder="Write your message..."
                rows="5"
                className="w-full border border-gray-300 rounded-lg px-4 py-2 focus:outline-none focus:ring-2 focus:ring-[#ae3e34]"
              ></textarea>
            </div>
            <button
              type="submit"
              className="bg-[#ae3e34] text-white px-6 py-2 rounded-lg hover:bg-[#932e28] transition"
            >
              Submit
            </button>
          </form>
        </div>
      </div>

      {/* Optional Map Section */}
      <div className="container mx-auto px-6 pb-20">
        <iframe
          title="Company Location"
          className="w-full h-64 rounded-lg shadow-lg border"
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3153.409991038991!2d-122.08424998468135!3d37.421999779825664!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x808fb5c4e3e9e71f%3A0x68567d2816d04b4e!2sGoogleplex!5e0!3m2!1sen!2sin!4v1618310346172!5m2!1sen!2sin"
          allowFullScreen=""
          loading="lazy"
        ></iframe>
      </div>
    </div>
  );
};

export default Contact;
